import React, { useEffect, useState, useContext, useMemo } from "react";
import { Typography, Box, Backdrop, CircularProgress, TextField, MenuItem, Button, Stack} from "@mui/material";
import Header from "./Header";
import { API } from "../conf";
import { Context } from "../App";

export default function Rapport() {
    const { updateConnect } = useContext(Context)
    const [organisation, setOrganisation] = useState(JSON.parse(sessionStorage.getItem('eglise')))
    const [agent, setAgent] = useState(JSON.parse(sessionStorage.getItem('user')))
    const [eglises, setEglises] = useState([])
    const [egliseId, setEgliseId] = useState('')
    const months = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Aout", "Septembre", "Octobre", "Novembre", "Décembre"]
    const [loading, setLoad] = useState(true)
    const [cloture_months, setCloture_months] = useState([])
    const [cloture_years, setCloture_years] = useState([])
    const [month, setMonth] = useState('')
    const [year, setYear] = useState('')
    const [dispo_dates, setDispo_dates] = useState([])
    const [pdf, setPdf] = useState()
    
    const eglise = useMemo(()=>organisation&&!organisation.isFederation ? organisation : eglises.find(el=>el._id===egliseId), [egliseId, eglises, organisation])

    function getRapport(month) {
        setPdf()
        if(eglise?._id){    
            setLoad(true)
            fetch(API.concat(`/eglises/${eglise._id}/rapport/${year}/${month}`), {
                method:'GET',
                headers: {
                    Accept: 'application/pdf',
                    'Content-Type': 'application/pdf',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                }
            }).then(async response=>{
                const token = response.headers.get('x-auth-token')
                if(response.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                }else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                    }
                    if (response.status === 200) {
                        const blob = await response.blob()
                        setPdf(URL.createObjectURL(blob))
                    }
                    setLoad(false)
                }
            })
        }
    }

    function reset() {
        setCloture_months([])
        setCloture_years([])
        setMonth('')
        setYear('')
        setDispo_dates([])
        setPdf()
    }

    useEffect(()=>{
        function get_cloture_dates(categorie) {return new Promise((resolve, reject) => {
            fetch(API.concat(`/${categorie}/${eglise.number}/years/months`), {
                method:'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                }
            }).then(async response=>{
                const token = response.headers.get('x-auth-token')
                if(response.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                }else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                    }
                    if (response.status === 200) {
                        const json = await response.json()
                        resolve(json)
                    }
                }
            })
        })}

        if(eglise?._id) {
            setLoad(true)
            get_cloture_dates('dons').then(ddons =>{
                get_cloture_dates('depenses').then(deps=>{
                    setDispo_dates(ddons.concat(deps))
                    const dyears = Array.from(new Set(ddons.concat(deps).map(item => item._id))).sort((a, b) => b-a)
                    setCloture_years(dyears);
                    setLoad(false)
                })
            })
        }
    }, [eglise])   
    
    useEffect(()=>{
        if (organisation&&organisation.isFederation) {
            setLoad(true)
            fetch(API.concat(`/eglises/by/${JSON.stringify(agent.eglises?.length>0 ? {_id:{$in: agent.eglises}}:{isFederation: false, isUnion: false})}`), {
                method:'GET',
                headers:{
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                }
            }).then(async(response) => {
                const token = response.headers.get('x-auth-token')
                if(response.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                }else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                    }
                    if (response.status === 200) {
                        const json = await response.json();
                        setEglises(json)
                        setLoad(false)
                    }
                }
            })
        }
    }, [organisation])

    useEffect(()=>{
        setOrganisation(JSON.parse(sessionStorage.getItem('eglise')))
        setAgent(JSON.parse(sessionStorage.getItem('user')))
    },[])
    
    return(
        <div style={{display:'flex', flexDirection:'column', height:'100vh'}}>
            <Header/>
            <Typography sx={{textAlign:'center', marginTop:'20px', fontSize:26}}>Rapport mensuel</Typography>
            {organisation&&organisation.isFederation&&<TextField select size="small" label="église" sx={{alignSelf:'end',marginBottom:3, width:'25%', marginRight:3, minWidth:'200px'}} value={egliseId} onChange={e=>setEgliseId(old=>{if(old!==e.target.value)reset(); return e.target.value})}>
                {eglises.map(eglise=><MenuItem key={eglise._id} value={eglise._id}>{`${eglise.nom} - ${eglise.commune.toUpperCase()}`}</MenuItem>)}
            </TextField>}
            {eglise&&<Box sx={{paddingX:'20px', marginTop:'30px', display:'flex', flexDirection:'column', flex:1}}>
                <Stack direction='row' spacing={5}>
                    <TextField
                    id="outlined-select-currency"
                    select
                    sx={{minWidth:'300px', marginBottom:'25px'}}
                    required
                    label="Année"
                    value={year}
                    onChange={(e)=> {
                        setYear(Number(e.target.value))
                        const dmonths = Array.from(new Set(dispo_dates.filter(item => item._id === Number(e.target.value)).map(x => x.months).flat())).sort((a, b) => a-b)
                        setCloture_months(dmonths);
                        setMonth('')
                    }}
                    >
                    {loading ? <CircularProgress color="inherit" />
                    :cloture_years.map((year, index) => (
                        <MenuItem key={index} value={year}>
                            <Typography sx={{}}>{year}</Typography> 
                        </MenuItem>
                    ))}
                    </TextField>
                    {year !== '' && <TextField
                    id="outlined-select-currency"
                    select
                    sx={{minWidth:'300px', marginBottom:'25px'}}
                    required
                    label="Mois"
                    value={month}
                    onChange={(e)=> {
                        setMonth(Number(e.target.value))
                        getRapport(Number(e.target.value))
                    }}
                    >
                    {loading ? <CircularProgress color="inherit" />
                    :cloture_months.map((month, index) => (
                        <MenuItem key={index} value={month}>
                            <Typography sx={{}}>{months[month-1]}</Typography> 
                        </MenuItem>
                    ))}
                    </TextField>}
                </Stack>
                
                {month !=='' && !loading && (pdf ? <embed src={pdf} width='100%' height='100%' type="application/pdf" style={{marginTop:20}} /> :
                <Typography textAlign='center'>Une erreur est survenue lors de la récupération du rapport, veuillez réessayer plus tard.<br/>Si le problème persiste veuillez contacter votre administrateur.</Typography>)}
            </Box>}

            <Backdrop open={loading}><CircularProgress color="inherit" /></Backdrop>
        </div>
    )
}